import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NoteIcon } from '../../../components/Icons';
import FirefoxSafeIcon from '../../../components/FirefoxSafeIcon';
import TooltipOnHover from '../../../components/TooltipOnHover';

function NoteLinkElement(_ref) {
  var url = _ref.url,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["url", "children"]);

  return url ? React.createElement("a", Object.assign({
    href: url
  }, props), children) : React.createElement("span", props, children);
}

var NoteLinkDecoratorComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(NoteLinkDecoratorComponent, _Component);

  function NoteLinkDecoratorComponent() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NoteLinkDecoratorComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NoteLinkDecoratorComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      e.preventDefault();
      var _this$props = _this.props,
          noteId = _this$props.noteId,
          onClick = _this$props.onClick,
          onMetaClick = _this$props.onMetaClick;

      if (e.metaKey || e.ctrlKey) {
        // Handle both cmd + click on mac & ctrl + click on windows
        onMetaClick({
          noteId: noteId
        });
      } else {
        onClick({
          noteId: noteId
        });
      }
    });

    return _this;
  }

  _createClass(NoteLinkDecoratorComponent, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          onMouseDown = _this$props2.onMouseDown,
          attributes = _this$props2.attributes,
          isSelected = _this$props2.isSelected,
          notFound = _this$props2.notFound,
          noteId = _this$props2.noteId,
          url = _this$props2.url;
      var disabledLink = notFound || !noteId;
      return React.createElement(TooltipOnHover, {
        id: "note-not-found",
        tooltipContent: "Note not found",
        placement: "top",
        disabled: !disabledLink
      }, React.createElement(NoteLinkElement, Object.assign({
        url: url,
        "data-editor": "note-link-".concat(noteId),
        onClick: this.handleClick,
        onMouseDown: onMouseDown
      }, attributes), React.createElement("span", {
        className: classNames('font-weight-medium pointer', 'padding-horizontal-smaller is-clickable', {
          'is-selected': isSelected
        }, disabledLink ? 'background-shade-50 shade-20' : 'entity-highlight')
      }, React.createElement("span", {
        className: "padding-right-smaller margin-left-smallest",
        style: {
          verticalAlign: '1px'
        }
      }, React.createElement(FirefoxSafeIcon, {
        className: "note-link-icon"
      }, React.createElement(NoteIcon, {
        size: 12
      }))), children)));
    }
  }]);

  return NoteLinkDecoratorComponent;
}(Component);

_defineProperty(NoteLinkDecoratorComponent, "propTypes", {
  noteId: PropTypes.string,
  url: PropTypes.string,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  onMetaClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  attributes: PropTypes.object,
  children: PropTypes.node.isRequired,
  notFound: PropTypes.bool
});

_defineProperty(NoteLinkDecoratorComponent, "defaultProps", {
  onClick: function onClick() {},
  onMetaClick: function onMetaClick() {}
});

export default NoteLinkDecoratorComponent;